import { Badge, Group, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

import type { WeeklyDetail, WeeklyMetrics } from "@msc/shared";

import { formatProzent, minBudgetProzent } from "../../lib/weekly.js";
import { TicketSummary } from "./TicketSummary.js";

/**
 * Kompakte Kennzahlen unter dem Kundennamen: kleinstes Restbudget-% und
 * Ticketzeile. Fehlt der Kunde in den (ggf. eingefrorenen) Kennzahlen — etwa
 * ein ehemaliger Kunde —, erscheint nichts: weder „0" noch „keine Jira-Zuordnung".
 */
export function RowMetrics({
  customerId,
  metrics,
  links,
}: {
  customerId: string;
  metrics: WeeklyMetrics;
  links: WeeklyDetail["links"];
}) {
  const { t } = useTranslation();
  const hatProjekte = metrics.budget.rows.some((r) => r.customerId === customerId);
  const budget = minBudgetProzent(metrics.budget.rows, customerId);
  const tickets = metrics.tickets.byCustomer[customerId];

  return (
    <>
      {hatProjekte && (
        <Group gap={4}>
          <Text size="xs" c={budget.hervorheben ? "red" : "dimmed"} fw={budget.hervorheben ? 700 : 400}>
            {`${t("weekly.metrics.budgetLeftShort")}: ${
              budget.prozent === null ? t("weekly.metrics.noBudget") : formatProzent(budget.prozent)
            }`}
          </Text>
          {/* Grund als Text, nicht nur als Farbe. */}
          {budget.lowBudget && (
            <Badge size="xs" color="red" variant="light">
              {t("weekly.metrics.lowBudget")}
            </Badge>
          )}
          {budget.endingSoon && (
            <Badge size="xs" color="orange" variant="light">
              {t("weekly.metrics.endingSoon")}
            </Badge>
          )}
        </Group>
      )}
      {tickets !== undefined &&
        (tickets.mapped ? (
          <TicketSummary
            stats={tickets}
            firstResponseMode={metrics.firstResponseMode}
            jiraBrowseBaseUrl={links.jiraBrowseBaseUrl}
            kompakt
          />
        ) : (
          <Text size="xs" c="dimmed">
            {t("weekly.metrics.noJiraMapping")}
          </Text>
        ))}
    </>
  );
}
